import { createSelector } from '@reduxjs/toolkit';
import {
  selectItemById, defaultItemSelectorByVanityUrlLowercase,
} from '../lib';
import { venueSelectors } from '..';

export const getVenueById = venueSelectors.selectById;

export const getVenueByVanityUrl = createSelector(
  venueSelectors.selectEntities,
  selectItemById,
  defaultItemSelectorByVanityUrlLowercase,
);
